// GET Groups

import {ErrorResArr, PageInfo} from './globals'

export interface IResGroups {
  allGroupAssignments: AllGroups
}

export interface AllGroups {
  pageInfo: PageInfo
  edges: EdgeGroups[]
  totalCount: number
  __typename: string
}

export interface EdgeGroups {
  node: NodeGroups
}

export interface NodeGroups {
  id: string
  created: string
  name: string
  visibleForTickets?: boolean
  // Telephony (VICIdial inbound group) status
  vicidialIngroupId?: string
  vicidialSyncedAt?: string | null
  vicidialRingStrategy?: string
  telephonyActive?: boolean
  assignedNumbersCount?: number
  telephonyMembersCount?: number
  supervisors: IMembersSet
  user: IMembersSet
  organization: IOrganization | null
}

export interface IOrganization {
  id: string
  name: string
}

export interface ISupervisor {
  id: string
  firstName: string
  lastName: string
  email: string
  rol: string
}
export interface IMembersSet {
  edges: IMembersNode[]
}
export interface IMembersNode {
  node: INodeMembers
}

interface INodeMembers {
  id: string
  firstName: string
  lastName: string
  email: string
  rol: string
  created: string
  updated: string
}

// MUTATIONS
export interface IResAddAssignmentGroup {
  createGroupAssignmentMutation?: IAssignmentGroupPayload
  updateGroupAssignmentMutation?: IAssignmentGroupPayload
}

export interface IAssignmentGroupPayload {
  groupAssignment: IAssignmentGroup | null
  success: boolean
  errors: Array<{field?: string; message?: string}>
}

export interface IAssignmentGroup {
  id: string
}

export interface IAssignmentGroupSimple {
  id: string
  name: string
}

export interface IResGroupsSimple {
  allAssignmentGroupsList: IAssignmentGroupSimple[]
}

// Multi-channel support
export type ChannelProvider = 'TWILIO' | 'BOTMAKER' | 'META'
export type ChannelType = 'SMS' | 'WHATSAPP' | 'VOICE'

export interface Channel {
  id: number | null
  provider: ChannelProvider
  channel_type: ChannelType
  phone_number: string
  webhook_token: string
  webhook_url_twilio: string
  webhook_url_botmaker: string
  assigned_member_ids: number[]
  is_active: boolean
  credentials: Record<string, string>
  created_at?: string
  updated_at?: string
}

export const CHANNEL_TYPE_OPTIONS: Record<ChannelProvider, ChannelType[]> = {
  TWILIO: ['SMS', 'WHATSAPP', 'VOICE'],
  BOTMAKER: ['WHATSAPP'],
  META: ['WHATSAPP'],
}
